import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { UnitRepository } from '@app/domain/ports/tpv/unit.repository';
import { TpvUnitListItem, UnitCreatedResult } from '@app/domain/models/tpv/unit.model';
import { TpvUnitDetail } from '@app/domain/models/tpv/entity-detail.model';
import { CreateUnitRequest } from '@app/data/dtos/tpv/unit.dto';
import { UpdateUnitRequest } from '@app/data/dtos/tpv/company-update.dto';

/**
 * Mock del CRUD de unidades para pruebas sin backend (toggle tpvUseMocks).
 * Simula latencia realista y devuelve un UUID al crear.
 */
@Injectable()
export class UnitMockDataSource extends UnitRepository {
  private readonly units: TpvUnitListItem[] = [
    { idUnit: 'mock-uuid-unit-1', isPrimary: true, name: 'Unidad Principal', status: 'ACTIVO' },
    { idUnit: 'mock-uuid-unit-2', isPrimary: false, name: 'Caja 2', status: 'ACTIVO' },
  ];

  override listUnits(_idCompany: string): Observable<TpvUnitListItem[]> {
    return of([...this.units]).pipe(delay(300));
  }

  override getUnitById(idCompany: string, idUnit: string): Observable<TpvUnitDetail> {
    const u = this.units.find((x) => x.idUnit === idUnit) ?? this.units[0];
    return of<TpvUnitDetail>({
      idUnit: u.idUnit,
      idCompany,
      name: u.name ?? 'Unidad Mock',
      companyName: 'Empresa Demo',
      socialName: 'Empresa Demo SA de CV',
      status: u.status,
      address: { state: 'Ciudad de Mexico', city: 'CDMX', cp: '06000', neighborhood: 'Centro', town: 'Cuauhtemoc', street: 'Calle Demo', extNumber: '1', description: 'Mock' },
      contact: { name: 'Contacto Demo', rol: 'Admin', email: 'demo@unidad.mx', telephonePrincipal: '5555555555' },
      bank: { bank: '012', clabe: '012180012345678901', numAccount: '1234567890' },
    }).pipe(delay(300));
  }

  override createUnit(_idCompany: string, payload: CreateUnitRequest): Observable<UnitCreatedResult> {
    return of({
      idUnit: `mock-uuid-unit-${this.units.length + 1}`,
      isPrimary: false,
      name: payload.unit?.name ?? 'Unidad Mock',
      status: 'ACTIVO',
    }).pipe(delay(400));
  }

  override updateUnit(_idCompany: string, _idUnit: string, _payload: UpdateUnitRequest): Observable<void> {
    return of(void 0).pipe(delay(400));
  }

  override deleteUnit(_idCompany: string, _idUnit: string): Observable<void> {
    return of(void 0).pipe(delay(400));
  }
}
